const Promise = window.Promise || require('promise')
const request = require('superagent-promise')(require('superagent'), Promise)
const OAUTH_API_END_POINT = 'https://oauth.4gamers.com.tw'
const WIRFORCE_API_END_POINT = 'https://api.wirforce.com.tw/v2017'

const generateResponse = (res) => {
  const response = JSON.parse(res.text)
  // console.log(response)
  if (typeof response.data !== 'undefined' && typeof response.data === 'object') {
    if (typeof response.paginator !== 'undefined' && typeof response.paginator === 'object') {
      return Promise.resolve(response)
    }
    return Promise.resolve(response.data)
  } else if (typeof response.data === 'undefined' && response.error.code === 200) {
    return Promise.resolve(null)
  } else {
    return Promise.reject({
      code: response.error.code,
      type: response.error.type,
      error: response.error
    })
  }
}

const generateErrorResponse = (err) => {
  console.log('error')
  return Promise.reject({
    err: err
  })
}

const generateOauthResponse = (res) => {
  const response = JSON.parse(res.text)
  console.log('success')
  return Promise.resolve(response)
}

export default {
  OAUTH_API_END_POINT: OAUTH_API_END_POINT,
  WIRFORCE_API_END_POINT: WIRFORCE_API_END_POINT,
  accessToken (code) {
    let params = {'grant_type': 'authorization_code', 'client_id': process.env.OAUTH.clientId, 'client_secret': process.env.OAUTH.clientSecret, 'redirect_uri': process.env.OAUTH.redirectUri, 'code': code}
    let req = request.post(OAUTH_API_END_POINT + '/oauth/token')
    return req
      .type('form')
      .send(params)
      .end()
      .then(generateOauthResponse, generateErrorResponse)
  },
  me (token) {
    let req = request.get(WIRFORCE_API_END_POINT + '/auth/me')
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  payment (token) {
    let req = request.get(WIRFORCE_API_END_POINT + '/auth/me/payment')
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  meRegister (token) {
    let req = request.get(WIRFORCE_API_END_POINT + '/auth/me/registered')
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  meSeats (token) {
    let req = request.get(WIRFORCE_API_END_POINT + '/auth/me/seats')
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  },
  notification (token) {
    let req = request.post(WIRFORCE_API_END_POINT + '/auth/me/seats/notification')
    return req
      .send()
      .set('Authorization', token)
      .end()
      .then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js